module.exports = __webpack_public_path__ + "static/img/5.36f5355.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/5.jpg
// module id = QTRA
// module chunks = 12